import { IonImg, IonText } from '@ionic/react';
import React, { useState } from 'react';
import * as commonCss from '../../styles/common';
import { SkeletonText } from '../SkeletonText';

interface ImgFallbackProps {
  src?: string;
  alt: string;
}

const ImgFallback: React.FC<ImgFallbackProps> = ({ src, alt }) => {
  const [showFallback, setShowFallback] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleError = () => {
    setShowFallback(true);
    setLoading(false);
  };

  const imgFallbackCss = {
    container: [commonCss.centered, commonCss.italics, commonCss.smallText],
  };

  return (
    <div css={imgFallbackCss.container}>
      {loading && <SkeletonText height="194px" />}
      {showFallback ? (
        <IonText>Image not available</IonText>
      ) : src ? (
        <IonImg src={src} alt={alt} onIonError={handleError} onIonImgDidLoad={() => setLoading(false)} />
      ) : null}
    </div>
  );
};

export default ImgFallback;
